export { default } from './GaleriaFotos';
